/* eslint-disable no-nested-ternary */
/* eslint-disable camelcase */
/* eslint-disable prefer-destructuring */
import React, { useContext } from 'react';
import { PNCounterIcon } from '@mummssoftware/global-context/PNCounter';
import { ENTITY_PATIENT_CARE_PLAN_PROBLEM_TASK } from '@mummssoftware/global-context/PNCounter/constants';
import { definedAndSuffix } from '@mummssoftware/utils/formatters';
import { parseDateYYYYMMDD } from '@mummssoftware/utils/dates';
import { property } from 'lodash-es';
import { Nil } from '@mummssoftware/utils/primitives';
import { AssistanceContext } from '../Context/AssistanceContext';

const getFirstTaskInWeekMap = (weekMap: mumms.WeekSummaryTaskRow['weeks']) =>
  weekMap && weekMap[Object.keys(weekMap)[0]];

export const NoteCountCellRenderer = (props: any) => {
  const sampleWeekDto = getFirstTaskInWeekMap(props?.data?.weeks);
  return props.data ? (
    /* eslint camelcase: ["error", {allow: ["role_group_name"]}] */
    <PNCounterIcon
      patientNumber={props?.data?.patientnumber}
      entityKey={sampleWeekDto?.entitykey}
      entityName={sampleWeekDto?.tasktext}
      entityType={ENTITY_PATIENT_CARE_PLAN_PROBLEM_TASK}
    />
  ) : (
    <></>
  );
};

const _X = definedAndSuffix('X');

const isBefore = (a: string) => (b: string) =>
  parseDateYYYYMMDD(b) <= parseDateYYYYMMDD(a);

const noTasksCompleted = (weekDto: mumms.WeekSummaryTaskWeek | Nil) =>
  !weekDto || weekDto.weekcombinedtotal === 0;

const formatWeekCount = (
  includeRefused: boolean,
): ((weekDto: mumms.WeekSummaryTaskWeek) => string) =>
  includeRefused ? property('weekcombinedtotal') : property('weektotal');

const getWeekCellValue = (
  weekDto: mumms.WeekSummaryTaskWeek | null | undefined,
  isBeforeEffDate: boolean,
  includeRefused: boolean,
) => {
  if (isBeforeEffDate && noTasksCompleted(weekDto)) {
    return '';
  }
  return weekDto
    ? formatWeekCount(includeRefused)(weekDto as mumms.WeekSummaryTaskWeek)
    : 0;
};

export const taskPeriodIsWeek = (task: mumms.WeekSummaryTaskDto) =>
  task.period === 'week';

const isCompliant = (
  taskDto: mumms.WeekSummaryTaskDto,
  weekDto: mumms.WeekSummaryTaskWeek | null,
) => weekDto && weekDto.weekcombinedtotal >= taskDto.frequency;

const getTaskCellShade = (
  taskDto: mumms.WeekSummaryTaskDto,
  weekDto: mumms.WeekSummaryTaskWeek | null,
  isBeforeEffDate: boolean,
) => {
  if (isBeforeEffDate) {
    return '#c2c2c2';
  }
  if (taskPeriodIsWeek(taskDto) && !isCompliant(taskDto, weekDto)) {
    return '#f6877f';
  }
  return '';
};

export const TaskWeekCellRenderer = (props: any) => {
  const { includeRefused } = useContext(AssistanceContext);

  if (!props.data) {
    return <></>;
  }

  const { startDate, data, eGridCell } = props;
  const { weeks, effectivedate } = data;
  const weekDto = weeks[startDate];

  const isBeforeEffDate = isBefore(effectivedate)(startDate);
  const formattedCount = getWeekCellValue(
    weekDto,
    isBeforeEffDate,
    includeRefused,
  );

  eGridCell.style.backgroundColor = getTaskCellShade(
    data,
    weekDto,
    isBeforeEffDate,
  );

  return (
    <div
      style={{
        fontWeight: formattedCount ? 600 : 'normal',
        userSelect: 'none',
      }}
    >
      {formattedCount}
    </div>
  );
};
